<template>
  <div class="sc-header"
       :class="{'rounded-top': !forceFullScreen}"
       :style="{background: colors.header.bg, color: colors.header.text, fontFamily: colors.font}"
  >
    <slot v-if="imageUrl && colors.header.logoOnly">
      <img class="sc-header--img" :src="imageUrl" alt="" height="100%"/>
    </slot>
    <slot v-else>
      <img v-if="imageUrl" class="sc-header--img border-radius-50" :src="imageUrl" alt="" height="36px" width="36px"/>
      <div v-if="!disableUserListToggle" class="sc-header--title enabled" @click="toggleUserList"> {{title}} </div>
      <div class="sc-header--title" :style="{fontSize: colors.header.fontSize, padding: colors.header.padding}" v-html="$t('welcome')"></div>
    </slot>

    <div v-if="colors.header.showModalViewButton || colors.header.showWideViewButton || showCloseButton" class="sc-header--actions">
      <div
        v-if="colors.header.showModalViewButton && !forceFullScreen"
        class="sc-header--modal-view-button"
        @click="$emit('toggleModalView')"
      >
        <icon-modal-view-collapse v-if="modalView" :fill="closeBtnColor"/>
        <icon-modal-view v-else :fill="closeBtnColor"/>
      </div>
      <div
        v-if="colors.header.showWideViewButton && !forceFullScreen"
        class="sc-header--wide-view-button"
        @click="$emit('toggleWideView')"
      >
        <icon-wide-view-collapse v-if="wideView" :fill="closeBtnColor"/>
        <icon-wide-view v-else :fill="closeBtnColor"/>
      </div>
      <div v-if="showCloseButton" class="sc-header--close-button" @click="onClose">
        <icon-cross class="display-none display-mobile-block" :fill="closeBtnColor"/>
        <icon-arrow-down class="display-block display-mobile-none" :fill="closeBtnColor"/>
      </div>
    </div>
  </div>
</template>
<script>

import IconCross from './icons/icons/IconCross'
import IconArrowDown from './icons/icons/IconArrowDown'
import IconWideView from './icons/icons/IconWideView'
import IconWideViewCollapse from './icons/icons/IconWideViewCollapse'
import IconModalView from './icons/icons/IconModalView'
import IconModalViewCollapse from './icons/icons/IconModalViewCollapse'

export default {
  components: { IconCross, IconArrowDown, IconWideView, IconWideViewCollapse, IconModalView, IconModalViewCollapse },
  props: {
    imageUrl: {
      type: String,
      default: ''
    },
    title: {
      type: String
    },
    onClose: {
      type: Function,
      required: true
    },
    colors: {
      type: Object,
      required: true
    },
    disableUserListToggle: {
      type: Boolean,
      default: false
    },
    showCloseButton: {
      type: Boolean,
      default: false
    },
    forceFullScreen: {
      type: Boolean,
      default: false
    },
    wideView: {
      type: Boolean,
      default: false
    },
    modalView: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggleUserList () {
      this.inUserList = !this.inUserList
      this.$emit('userList', this.inUserList)
    }
  },
  data () {
    return {
      inUserList: false
    }
  },
  computed: {
    closeBtnColor () {
      return this.colors.header.closeBtn?.color || this.colors.header.text
    }
  }
}
</script>
